import { UndefinedCertData, IUndefinedCertData } from './types';

enum Action {
  GET_SERT = 'actionActivateCert',
  ACTION_TEXT = 'Активировать сертификат',
}

const undefinedCertData = (data: IUndefinedCertData): UndefinedCertData => ({
  id: data!.id || '',
  childName:
    data!.last_name && data!.first_name
      ? `${data.last_name} ${data.first_name}`
      : 'Без имени',
  isUndefinedType: true,
  certificateType: data!.certificate_type,
  certificateNumber: data!.certificate_number,
  toIssue: data!.certificate_request ? null : data!.toIssue,
  toConfirm: data!.toConfirm,
  action: Action.GET_SERT,
  actionText: Action.ACTION_TEXT,
});

export default undefinedCertData;



// WEBPACK FOOTER //
// ./src/services/pfdod/utils/undefinedCertData.ts